import { useEffect, useState } from 'react';
import { useForm, yupResolver, } from '@mantine/form';
import { TextInput, Modal, Text, Center, Button, Code, Checkbox, SimpleGrid, NumberInput } from '@mantine/core';

import { useParams } from 'react-router-dom';
import useGetMatchLimitDetails from './useGetMatchLimitDetails';
import useEdit from './useEdit';
import { useDisclosure } from '@mantine/hooks';

import { object, number } from "yup";
import LoadingErrorContainer from '../../../components/placeholders/LoadingErrorContainer';

const userSchema = object().shape({
});

function Demo() {
    const {
        editMutation
    } = useEdit()


    const { data, isPending, isError } = useGetMatchLimitDetails();

    useEffect(() => {
        if (!isPending && data) {
            form?.setValues({
                ...data,

            })
        }
    }, [data, isPending]);

    const [submittedValues] = useState('');

    const form = useForm({
        // mode: 'uncontrolled',
        initialValues: {
            id: "", free: "", pro: "", premium: "",


        },
        validate: yupResolver(userSchema)
    });



    const handleEdit = form.onSubmit(async (values) => {

        const free = form.values.slug == 'blurred-match' ? values.free ? 1 : 0 : values.free;
        const premium = form.values.slug == 'blurred-match' ? values.premium ? 1 : 0 : values.premium;
        const formData = new FormData();
        formData.append("id", values?.id);
        formData.append("free", free);
        formData.append("premium", premium);
        //  formData.append("pro", values?.pro);

        editMutation.mutate(formData)
    })
    const [opened, { open, close }] = useDisclosure(false); return (
        <LoadingErrorContainer isLoading={isPending}>
            <h1>Edit Match Limit</h1>

            <SimpleGrid cols={2}>

                <TextInput
                    label="Type"
                    placeholder="Enter Type"
                    key={form.key('type')}
                    Limit={{ alignSelf: "baseline" }}
                    {...form.getInputProps('type')}
                    disabled
                />
                <div />

                {/* <NumberInput
                    label="Premium (With Agency)"
                    placeholder="Enter Premium"
                    key={form.key('premium')}
                    Limit={{ alignSelf: "baseline" }}
                    {...form.getInputProps('premium')}

                /> */}
                {form.values.slug != 'blurred-match' ? (
                    <NumberInput
                        label="Premium (With Agency)"
                        placeholder="Enter Premium"
                        key={form.key('premium')}
                        Limit={{ alignSelf: "baseline" }}
                        {...form.getInputProps('premium')}

                    />
                ) : <Checkbox label="Show blurred Image in Premium (with agency)" key={form.key('premium')} checked={!!form.values.premium} {...form.getInputProps('premium')}
                    style={{ alignSelf: "baseline" }}

                    onChange={(event) => form.setFieldValue("premium", event.currentTarget.checked)}

                />}



                {form.values.slug != 'blurred-match' ? (
                    <NumberInput
                        label="Free (Without Agency)"
                        placeholder="Enter Free"
                        key={form.key('free')}
                        Limit={{ alignSelf: "baseline" }}
                        {...form.getInputProps('free')}


                    />

                ) : <Checkbox
                    checked={!!form.values.free}
                    label="Show blurred Image in Free (without agency)" key={form.key('free')}  {...form.getInputProps('free')}
                    style={{ alignSelf: "baseline" }} />}


                <br></br>



                <div />
            </SimpleGrid>
            <Button type="submit" mt="md" onClick={handleEdit} loading={editMutation?.isPending}>
                Submit
            </Button>
            &nbsp;
            <Button type="button" mt="md" color="red" onClick={open} >
                Return
            </Button>

            <Modal opened={opened} onClose={close}
                centered
                title="Confirm">

                <Text>Are you sure you want to leave this page without saving?</Text>


                <Center mt={"md"}>
                    <Button onClick={() => window.history.back()}
                    >Confirm</Button>
                </Center>

            </Modal >
            {submittedValues && (
                <Code block mt="md">
                    {submittedValues}
                </Code>
            )}
        </LoadingErrorContainer>
    );
}



export default Demo;
